const { algoliasearch, instantsearch } = window;
const searchClient = algoliasearch('MMTNND4ZP7', '7906875c1faa3760e427c326f116ed76');
const search = instantsearch({
    indexName: 'messages',
    searchClient,
    future: {
        preserveSharedStateOnUnmount: true
    }
});
// Add div elements for new widgets to the HTML (simplified version)
document.querySelector('.search-panel__filters').innerHTML = `
  <h2>Filters</h2>
  <div id="clear-refinements"></div>
  <div id="stats"></div>
  <h3>Categories</h3>
  <div id="category-list"></div>
  <div id="date-range-input"></div>
`;
// Add stats element before searchbox
const statsElement = document.createElement('div');
statsElement.id = 'stats-top';
document.querySelector('#searchbox').parentNode.insertBefore(statsElement, document.querySelector('#searchbox'));
search.addWidgets([
    // Simple search box
    instantsearch.widgets.searchBox({
        container: '#searchbox',
        placeholder: 'Search for messages...',
        autofocus: true,
        searchAsYouType: true,
        showReset: true,
        showSubmit: false
    }),
    // Stats widgets to show result counts
    instantsearch.widgets.stats({
        container: '#stats-top',
        templates: {
            text: (data)=>{
                return `${data.nbHits} results found ${data.query ? `for "${data.query}"` : ''} in ${data.processingTimeMS}ms`;
            }
        }
    }),
    // Clear refinements button
    instantsearch.widgets.clearRefinements({
        container: '#clear-refinements',
        templates: {
            resetLabel: 'Clear all filters'
        }
    }),
    // Removed current refinements widget to simplify
    // Category filter - assuming your data has a category attribute
    // Simplified category filter
    instantsearch.widgets.refinementList({
        container: '#category-list',
        attribute: 'category',
        searchable: false,
        limit: 5
    }),
    // Custom date range picker using connectRange for better control
    instantsearch.widgets.panel({
        templates: {
            header: 'Date Range'
        }
    })(({ options })=>{
        try {
            // Create the custom widget using the range connector
            const customRangeWidget = instantsearch.connectors.connectRange((renderOptions, isFirstRender)=>{
                const { refine, range, start, widgetParams, instantSearchInstance } = renderOptions;
                const container = document.querySelector(widgetParams.container);
                // Initialize the widget HTML on first render
                if (isFirstRender) {
                    container.innerHTML = '<div class="custom-date-range"><div class="date-range-inputs"><div class="date-input-group"><label for="date-from">From:</label><input type="date" id="date-from" class="date-range-input-field"/></div><div class="date-input-group"><label for="date-to">To:</label><input type="date" id="date-to" class="date-range-input-field"/></div></div><button type="button" class="date-range-apply">Apply Date Range</button><div class="date-range-feedback"></div></div>';
                    // Apply button click handler
                    const applyButton = container.querySelector('.date-range-apply');
                    const fromInput = container.querySelector('#date-from');
                    const toInput = container.querySelector('#date-to');
                    const feedback = container.querySelector('.date-range-feedback');
                    applyButton.addEventListener('click', ()=>{
                        const fromValue = fromInput.value;
                        const toValue = toInput.value;
                        // Reset feedback
                        feedback.textContent = '';
                        feedback.classList.remove('success', 'error');
                        try {
                            // Validate inputs
                            if (!fromValue && !toValue) {
                                // If both inputs are empty, clear the refinement
                                refine([
                                    undefined,
                                    undefined
                                ]);
                                feedback.textContent = 'Date filter cleared';
                                feedback.classList.add('success');
                                return;
                            }
                            // Convert from date string to timestamp (add time to ensure full day coverage)
                            // Use UTC to match ISO format in the data
                            let fromTimestamp = fromValue ? new Date(fromValue + 'T00:00:00Z').getTime() : undefined;
                            // Convert to date string to timestamp (add time to ensure full day coverage)
                            // Use UTC to match ISO format in the data
                            let toTimestamp = toValue ? new Date(toValue + 'T23:59:59Z').getTime() : undefined;
                            // Validate the date range
                            if (fromTimestamp && toTimestamp && fromTimestamp > toTimestamp) {
                                feedback.textContent = 'End date must be after start date';
                                feedback.classList.add('error');
                                return;
                            }
                            console.log(`Applying date range: ${fromTimestamp} to ${toTimestamp}`);
                            // Apply the refinement with converted timestamps
                            refine([
                                fromTimestamp,
                                toTimestamp
                            ]);
                            // Show success message
                            feedback.textContent = 'Date range applied';
                            feedback.classList.add('success');
                        } catch (error) {
                            console.error('Error applying date filter:', error);
                            feedback.textContent = 'Invalid date format';
                            feedback.classList.add('error');
                        }
                    });
                    // Update inputs when current refinement changes from outside (like clear all filters)
                    instantSearchInstance.on('render', ()=>{
                        if (start[0] === undefined && start[1] === undefined) {
                            fromInput.value = '';
                            toInput.value = '';
                        }
                    });
                }
                // Update the input values based on current refinements
                const fromInput = container.querySelector('#date-from');
                const toInput = container.querySelector('#date-to');
                if (fromInput && toInput) {
                    if (start[0] !== -Infinity && start[0] !== undefined) {
                        // Create a proper Date object from the timestamp
                        const fromDate = new Date(Number(start[0]));
                        // Format to YYYY-MM-DD for the date input
                        fromInput.value = fromDate.toISOString().split('T')[0];
                        console.log('Set from date:', fromInput.value, 'from timestamp:', start[0]);
                    }
                    if (start[1] !== Infinity && start[1] !== undefined) {
                        // Create a proper Date object from the timestamp
                        const toDate = new Date(Number(start[1]));
                        // Format to YYYY-MM-DD for the date input
                        toInput.value = toDate.toISOString().split('T')[0];
                        console.log('Set to date:', toInput.value, 'from timestamp:', start[1]);
                    }
                }
            });
            return customRangeWidget({
                container: '#date-range-input',
                attribute: 'timestamp',
                min: new Date('2000-01-01').getTime(),
                max: new Date().getTime()
            });
        } catch (error) {
            console.error('Error initializing date range widget:', error);
            // Fallback simple date range message
            const container = document.querySelector('#date-range-input');
            if (container) container.innerHTML = '<div class="custom-date-range"><p>Date filtering is available for messages from 2000 to present.</p></div>';
            return null;
        }
    }),
    // Simplified hits template with robust image handling
    instantsearch.widgets.hits({
        container: '#hits',
        templates: {
            empty: 'No results found for <q>{{ query }}</q>',
            item: (hit, { html, components })=>{
                // Properly handle images based on hasImage and absoluteURL
                const showImage = hit.hasImage && hit.absoluteURL;
                const messageText = hit.content?.text || '';
                return html`
          <article class="hit" 
            data-hit-objectid="${hit.objectID}" 
            tabindex="0" 
            role="button" 
            aria-label="View details for message"
          >
            ${showImage ? html`
              <div class="hit-image">
                <img src="${hit.absoluteURL}" alt="Message attachment" />
              </div>
            ` : ''}
            <div class="hit-content ${!showImage ? 'hit-content-full' : ''}">
              <div class="hit-header">
                <span class="hit-sender">${hit.sender || ''}</span>
                ${hit.timestamp ? html`
                  <span class="hit-timestamp">
                    ${new Date(hit.timestamp).toLocaleDateString()} 
                    ${new Date(hit.timestamp).toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit'
                })}
                  </span>
                ` : ''}
              </div>
              <div class="hit-message">
                ${components.Highlight({
                    hit,
                    attribute: "content.text"
                })}
              </div>
              ${hit.readReceipt ? html`<p class="hit-receipt">${hit.readReceipt}</p>` : ''}
              ${hit.messageType ? html`<span class="hit-type">${hit.messageType}</span>` : ''}
              <p class="hit-view-more">View details</p>
            </div>
          </article>
        `;
            }
        },
        cssClasses: {
            root: 'search-hits',
            list: 'search-hits-list',
            item: 'search-hits-item'
        }
    }),
    // Configuration based on the actual data structure
    instantsearch.widgets.configure({
        hitsPerPage: 8,
        attributesToSnippet: [
            'content.text:40'
        ],
        snippetEllipsisText: '...',
        // Add attribute to ensure timestamp can be used for filtering
        numericAttributesForFiltering: [
            'timestamp'
        ],
        // Ensure sufficient results for testing
        typoTolerance: 'min',
        // Add proper attributes based on the data structure
        attributesToRetrieve: [
            'objectID',
            'content',
            'timestamp',
            'sender',
            'messageType',
            'hasImage',
            'absoluteURL',
            'readReceipt',
            'filePath'
        ]
    }),
    // Basic pagination
    instantsearch.widgets.pagination({
        container: '#pagination',
        padding: 2,
        showFirst: false,
        showLast: false,
        showPrevious: true,
        showNext: true
    })
]);
// Initialize modal functionality
function initializeModal() {
    const modal = document.getElementById('hit-details-modal');
    const modalOverlay = modal.querySelector('.modal-overlay');
    const modalClose = modal.querySelector('.modal-close');
    const modalContent = modal.querySelector('.modal-content');
    // Function to display hit details in modal
    window.showHitDetails = function(hit) {
        if (!hit) return;
        // Set modal title
        document.getElementById('modal-title').textContent = hit.content?.text || 'Item Details';
        // Prepare content HTML with proper image handling based on hasImage flag
        const showImage = hit.hasImage && hit.absoluteURL;
        const messageText = hit.content?.text || '';
        // Create HTML parts individually to avoid template literal parsing issues
        let contentHTML = '<div class="detail-content">';
        // Add image if available
        if (showImage) {
            contentHTML += '<div class="detail-image-container">';
            contentHTML += '<img class="detail-image" src="' + hit.absoluteURL + '" alt="Message attachment" />';
            contentHTML += '</div>';
        }
        // Add message title
        contentHTML += '<h3>' + (messageText || 'No message text') + '</h3>';
        // Add message details
        contentHTML += '<div class="detail-message-info">';
        contentHTML += '<p><strong>Sender:</strong> ' + (hit.sender || 'Unknown') + '</p>';
        if (hit.timestamp) contentHTML += '<p><strong>Date:</strong> ' + new Date(hit.timestamp).toLocaleString() + '</p>';
        if (hit.readReceipt) contentHTML += '<p><strong>Status:</strong> ' + hit.readReceipt + '</p>';
        if (hit.messageType) contentHTML += '<p><strong>Type:</strong> ' + hit.messageType + '</p>';
        contentHTML += '</div></div>';
        // Add metadata section
        contentHTML += '<div class="detail-metadata">';
        // Add all available metadata fields
        const excludeFields = [
            'objectID',
            'content',
            'absoluteURL',
            'description',
            '_highlightResult',
            '_snippetResult'
        ];
        for(const key in hit){
            if (excludeFields.includes(key)) continue;
            const value = hit[key];
            if (value !== undefined && value !== null) {
                let displayValue = value;
                // Format timestamp if present
                if (key === 'timestamp' && value) displayValue = new Date(value).toLocaleString();
                contentHTML += '<p class="detail-metadata-item">';
                contentHTML += '<strong>' + key + ':</strong> ';
                contentHTML += displayValue;
                contentHTML += '</p>';
            }
        }
        // Add nested content fields if present
        if (hit.content) {
            for(const contentKey in hit.content)if (contentKey !== 'text') {
                contentHTML += '<p class="detail-metadata-item">';
                contentHTML += '<strong>content.' + contentKey + ':</strong> ';
                contentHTML += hit.content[contentKey];
                contentHTML += '</p>';
            }
        }
        contentHTML += '</div>';
        // Set content and open modal
        modalContent.innerHTML = contentHTML;
        modal.classList.add('is-open');
        modalClose.focus();
        // Prevent body scrolling
        document.body.style.overflow = 'hidden';
    };
    // Event delegation for hit clicks
    document.getElementById('hits').addEventListener('click', function(e) {
        const hitElement = e.target.closest('.hit');
        if (hitElement) {
            const objectID = hitElement.dataset.hitObjectid;
            if (objectID) {
                const searchResults = search.helper.lastResults;
                if (searchResults) {
                    const hitData = searchResults.hits.find((h)=>h.objectID === objectID);
                    if (hitData) showHitDetails(hitData);
                }
            }
        }
    });
    // Also handle keyboard events for accessibility
    document.getElementById('hits').addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            const hitElement = e.target.closest('.hit');
            if (hitElement) {
                e.preventDefault();
                const objectID = hitElement.dataset.hitObjectid;
                if (objectID) {
                    const searchResults = search.helper.lastResults;
                    if (searchResults) {
                        const hitData = searchResults.hits.find((h)=>h.objectID === objectID);
                        if (hitData) showHitDetails(hitData);
                    }
                }
            }
        }
    });
    // Close modal when clicking close button
    modalClose.addEventListener('click', function() {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
    });
    // Close modal when clicking overlay
    modalOverlay.addEventListener('click', function() {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
    });
    // Close modal with Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
            modal.classList.remove('is-open');
            document.body.style.overflow = '';
        }
    });
}
search.start();
// Initialize modal after search is started
search.on('render', function() {
    try {
        initializeModal();
    } catch (error) {
        console.error('Error initializing modal:', error);
    }
});
// Add error handling for the entire application
window.addEventListener('error', function(event) {
    console.error('Caught error:', event.error);
});

//# sourceMappingURL=instantsearch-app.05590b82.js.map
